<template>
  <div>
       <stepheader :step="step"/>
         <div id="wizard2-p-0" role="tabpanel" aria-labelledby="wizard2-h-0" class="body current" aria-hidden="false" style="">
          <div class="row">
            <div class="col-12">
                Stiamo verificando lo stato del dispositivo...
            </div>
          
          </div>
     
											
 
  </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "findmyphone",

  props: {
    step: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  ticket: {
      type: Object,
      required: false,
    },
    code: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
     
    };
  },
  computed: {
   
  },
  components: {
   
  },
  mounted() {
  },
  methods: {
    fireaction:function(action,nextstep){
      switch(action){
       default:
             this.$emit("goto",nextstep)
          break;

      }

    },
   loaddata: function () {
    
    },

    authenticate:function(nextstep){

    }
  },
};
</script>